import MainComponent from './components/mainComponent';

function App() {
  return <MainComponent />;
}

export default App;
